export function SecurityReportsDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.SECURITY_REPORT)
        .setCustomActions({
            'getReports': {
                method: 'GET'
            },
            'getRecentVul': {
                method: 'GET',
                path: XRAY_RESOURCE.SECURITY_REPORT + '/recentVulnerabilities'
            },
            'getRecentComponents': {
                method: 'GET',
                path: XRAY_RESOURCE.SECURITY_REPORT + '/recentComponents'
            },
            'getTopVul': {
                method: 'GET',
                path: XRAY_RESOURCE.SECURITY_REPORT + '/topVulnerability'
            },
            'getTopArt': {
                method: 'GET',
                path: XRAY_RESOURCE.SECURITY_REPORT + '/topArtifact'
            },
            'getStatus': {
                method: 'GET',
                path: XRAY_RESOURCE.SECURITY_REPORT + '/status'
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/security_reports_dao.js